import { useState } from "react"
import {
  Folder,
  Forward,
  MoreHorizontal,
  Trash2,
  Bird,
  List,
  Mail,
  Map,
  Warehouse,
  ChevronDown,
  type LucideIcon,
} from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import type { NavLink } from "@/types/index"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@radix-ui/react-collapsible"

export function NavSystemAdmin() {
  const links: NavLink[] = [
    {
      name: "Organisations",
      url: "/app/admin/orgs/manage",
      icon: Warehouse,
    },
    {
      name: "Users",
      url: "/app/admin/users",
      icon: Map,
    },
    {
      name: "Records",
      url: "/app/admin/records",
      icon: List,
    },
    {
      name: "Species",
      url: "/app/admin/species",
      icon: Bird,
    },
    { name: "Messages", url: "/app/admin/messages", icon: Mail },
    { name: "Email", url: "/email", icon: Mail },
  ];

  const [open, setOpen] = useState(false)
  const { isMobile } = useSidebar()

  return (
    <Collapsible className="w-full" open={open} onOpenChange={setOpen}>
      <SidebarGroup className="group-data-[collapsible=icon]:hidden" >
        <CollapsibleTrigger asChild>
          <SidebarGroupLabel className="flex cursor-pointer items-center justify-between gap-2">
            <span>System Admin</span>
            <ChevronDown
              className={`h-4 w-4 transition-transform transform ${open ? "rotate-180" : "rotate-0"}`}
            />
          </SidebarGroupLabel>
        </CollapsibleTrigger>
        <CollapsibleContent asChild>
          <SidebarMenu  >
            {links.map((item) => (
              <SidebarMenuItem key={item.name}>
                <SidebarMenuButton asChild>
                  <a href={item.url}>
                    <item.icon />
                    <span>{item.name}</span>
                  </a>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </CollapsibleContent>
      </SidebarGroup>
    </Collapsible>
  )
}
